import { connect } from 'react-redux';

import { UserManagement } from '../components/user-management';

import { fetchUserList, updateUserInfo } from '../actions/admin';

const mapState = state => ({
  userToken: state.user.profile.token,
  users: state.admin.users,
  isUserListFetching: state.admin.isUserListFetching
});

const mapDispatch = {
  fetchUserList,
  updateUserInfo
};

export default connect(
  mapState,
  mapDispatch
)(UserManagement);
